<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 20:19:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refunddetail/index.vue
-->
<template>
  <div class="">
    <title-bar-back :title="'售后'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="top_pos">
      <!--步骤条 -->
      <top-step :stepIndex="stepIndexs(getAfterSaleInfo.status)" />
    </div>
    <div class="refund_detail_mr_con text_left">
      <!-- 状态信息 -->
      <refund-status />
      <!-- 价格信息 -->
      <refund-price @goHistory="goHistory" />
      <!-- 商品信息 -->
      <div class="refund_p_list">
        <div class="pro_title font_weight500 font14 colo087 text_left">
          商品信息
        </div>
        <div
          v-for="(item, index) in getAfterSaleInfo.userAfterSaleItemsVOS"
          :key="index"
        >
          <order-product-list
            v-if="!item.isGift"
            :listIndex="index"
            :pageShow="false"
            :item="item"
            :bgPad="'bg0'"
          />
          <!-- 赠品 -->
          <div v-if="item.isGift" class="free_product_list">
            <free-product
              :showBor="false"
              :freeProduct="item"
              :orderSn="getAfterSaleInfo.orderSn"
            />
          </div>
        </div>
      </div>
      <!--详细信息  -->
      <refund-det />
      <div class="refund_bottom_mr"></div>
    </div>
    <!-- 底部按钮 -->
    <refund-btn
      :btnList="bottomBtn(getAfterSaleInfo.status)"
      @clickBtn="clickBtn"
    />
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import TopStep from "./components/TopStep";
import RefundStatus from "./components/RefundStatus";
import RefundPrice from "./components/RefundPrice";
import RefundDet from "./components/RefundDet";
import RefundBtn from "./components/RefundBtn";
import OrderProductList from "../../list/components/OrderProductList";
import FreeProduct from "../../detail/components/FreeProduct";
export default {
  name: "RefundrList",
  components: {
    TitleBarBack,
    TopStep,
    RefundStatus,
    RefundPrice,
    OrderProductList,
    RefundDet,
    RefundBtn,
    FreeProduct
  },
  computed: {
    getAfterSaleInfo() {
      return this.$store.getters.getAfterSaleInfo;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    back() {
      this.$router.push("/order/refund/refundlist");
    },
    // getAfterSaleInfo
    getData() {
      this.$store
        .dispatch("order/getAfterSaleInfo", {
          params: { id: this.$route.query.id }
        })
        .then(() => {})
        .catch(() => {});
    },
    // 协商历史
    goHistory(id) {
      this.$router.push({
        path: "/order/refund/refundhistory",
        query: {
          id,
          afterSaleType: this.getAfterSaleInfo.afterSaleType,
          returnPrice: this.getAfterSaleInfo.returnPrice,
          reason: this.getAfterSaleInfo.reason,
          instruction: this.getAfterSaleInfo.instruction
        }
      });
    },
    // 顶部进度条
    stepIndexs(status) {
      switch (status) {
        case -32: //"财务售后驳回";
        case -31: // return "小二收货驳回";
        case -30: // return "小二售后驳回";
        case -1: // return "撤销售后";
        case 34: //"退款中"
        case 35: // return "售后成功";
          return 4;
        case 1: //"客服审核中"
          return 1;
        case 30: //"小二审核通过"
        case 31: //"待商品寄回"
          return 2;
        case 32: //"待商家收货"
        case 33: //"待财务审核"
          return 3;
      }
    },
    // 底部按钮
    bottomBtn(status) {
      switch (status) {
        case -32: //"财务售后驳回";
        case -31: // return "小二收货驳回";
        case -30: // return "小二售后驳回";
        case -1: // return "撤销售后";
        case 35: // return "售后成功";
          return ["联系客服"];
        case 1: //"客服审核中"
          return ["撤销售后"];
        case 30: //"小二审核通过"
        case 31: //"待商品寄回"
          return ["填写物流", "撤销售后"];
        case 32: //"待商家收货"
          return ["修改物流"];
        case 33: //"待财务审核"
          return ["联系客服"];
        case 34: //"退款中"
          return ["联系客服"];
      }
    },
    // 点击底部按钮
    clickBtn(btn) {
      switch (btn) {
        case "联系客服":
          this.$toast("点击联系客服");
          break;
        case "撤销售后":
          // cancelAfterSale
          this.$dialog
            .confirm({
              message: "您确定要撤销售后吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              this.$store
                .dispatch("order/cancelAfterSale", {
                  params: { id: this.$route.query.id }
                })
                .then(() => {
                  this.$toast("撤销售后成功");
                  this.getData();
                })
                .catch(() => {});
            })
            .catch(() => {});
          break;
        case "填写物流":
          this.$router.push({
            path: "/order/refund/addlogistics",
            query: {
              id: this.$route.query.id
            }
          });
          // this.$toast("填写物流");
          break;
        case "修改物流":
          this.$router.push({
            path: "/order/refund/addlogistics",
            query: {
              id: this.$route.query.id,
              modify: 1
            }
          });
          // this.$toast("修改物流");
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.top_pos {
  position: relative;
}
.refund_bottom_mr {
  height: 75px;
}
.refund_detail_mr_con {
  position: absolute;
  top: 78px;
  left: 0;
  right: 0;
  margin: 51px 12px 0;
}
.re_det_con {
  background: #fff;
  margin-top: 12px;
  padding: 0 12px;
}
.refund_p_list {
  margin: 12px 0 0 0;
  background: #fff;
  border-radius: 6px;
  .pro_title {
    padding: 12px;
  }
  .free_product_list {
    background: #fff;
    margin: 0 12px;
  }
}
</style>
